import Header from "../home/components/Header";
import Footer from "../home/components/Footer";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <span className="inline-flex items-center border border-stone-400 text-stone-500 text-xs tracking-widest px-4 py-1.5 rounded-full w-fit mb-6">
            ABOUT US
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-stone-900 tracking-wide leading-tight">
            会社概要
          </h1>
        </div>
      </section>

      {/* Company Info */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="flex flex-col gap-12">
            {/* Company Name */}
            <div className="flex flex-col md:flex-row gap-4 md:gap-12 border-b border-stone-200 pb-8">
              <span className="text-stone-500 text-sm tracking-wider w-32 shrink-0">会社名</span>
              <span className="text-stone-900 text-lg">株式会社AMYMAISON</span>
            </div>

            {/* Business */}
            <div className="flex flex-col md:flex-row gap-4 md:gap-12 border-b border-stone-200 pb-8">
              <span className="text-stone-500 text-sm tracking-wider w-32 shrink-0">事業内容</span>
              <div className="flex flex-col gap-2 text-stone-700">
                <span>セントマーケティング事業</span>
                <span>オリジナルフレグランス開発</span>
                <span>空間演出・ディフューザー設置</span>
                <span>ブランディングコンサルティング</span>
              </div>
            </div>

            {/* Address */}
            <div className="flex flex-col md:flex-row gap-4 md:gap-12 border-b border-stone-200 pb-8">
              <span className="text-stone-500 text-sm tracking-wider w-32 shrink-0">所在地</span>
              <span className="text-stone-700">〒000-000 東京都目黒区中目黒〇〇</span>
            </div>

            {/* Contact */}
            <div className="flex flex-col md:flex-row gap-4 md:gap-12 border-b border-stone-200 pb-8">
              <span className="text-stone-500 text-sm tracking-wider w-32 shrink-0">お問い合わせ</span>
              <div className="flex flex-col gap-2 text-stone-700">
                <span>TEL: 03-XXXX-XXXX</span>
                <span>Email: info@amymaison.co.jp</span>
              </div>
            </div>

            {/* Established */}
            <div className="flex flex-col md:flex-row gap-4 md:gap-12 border-b border-stone-200 pb-8">
              <span className="text-stone-500 text-sm tracking-wider w-32 shrink-0">設立</span>
              <span className="text-stone-700">2026年3月</span>
            </div>

            {/* CEO */}
            <div className="flex flex-col md:flex-row gap-4 md:gap-12 border-b border-stone-200 pb-8">
              <span className="text-stone-500 text-sm tracking-wider w-32 shrink-0">代表取締役</span>
              <span className="text-stone-700">山口 亜美</span>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="py-16 md:py-24 bg-stone-50">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <h2 className="text-2xl md:text-3xl font-light text-stone-900 tracking-wide mb-12">
            私たちの想い
          </h2>
          <div className="flex flex-col gap-6 text-stone-600 leading-loose">
            <p>
              AMYMAISONは、「香りの力で、人々の記憶に残る体験を創る」ことをミッションに設立されました。
            </p>
            <p>
              香りは五感の中で最も本能に近い感覚であり、言葉では表現できない感情や記憶を呼び起こす力を持っています。
              私たちはその力を信じ、お客様一人ひとりにとって特別な香りを創造し続けています。
            </p>
            <p>
              ホテル、商業施設、オフィス、個人のお客様まで、様々な空間に最適な香りを提案し、
              「あの時の香り」として心に残る体験を提供すること。それが私たちの誇りです。
            </p>
          </div>
        </div>
      </section>

      {/* Back to Home */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-stone-600 text-sm tracking-widest hover:text-stone-900 transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            トップページに戻る
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}